// SP
export const breakpointSp = 767;
// Tablet
export const breakpointTb = 768;
// PC
export const breakpointPc = 1025;
